import React, {useState, useEffect, useRef} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {DataTable} from 'primereact/datatable';
import {Column} from "primereact/column";
import {Panel} from "primereact/panel";
import axios from "axios";
import Cookies from "js-cookie";
import HelpComponent from "../components/HelpComponent";

const _FM_NotificationsPage = (props) => {

  const {t, i18n} = props;
  const navigate = useNavigate();
  const {id, action, entity} = useParams();
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(10);
  const dt = useRef(null);
  const [lazyParams, setLazyParams] = useState({
    first: Number(localStorage.getItem('notifications_first')) || 0,
    rows: Number(localStorage.getItem('notifications_rows')) || rows,
    page: Number(localStorage.getItem('notifications_page')) || 0,
    sortField: localStorage.getItem('notifications_sortField') || 'id',
    sortOrder: Number(localStorage.getItem('notifications_sortOrder')) || -1,
    filters: JSON.parse(localStorage.getItem('notifications_filters')) || null,
  });
  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams)
      window.App.setState({rerenderNotificationsList: false})
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "notification" + query,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setNotifications(response.data.data.items);
          setLoading(false);
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: 10, value: 10},
        {label: 20, value: 20},
        {label: 50, value: 50},
        {label: 200, value: 200}
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', notificationsSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    />
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', notificationsSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        {!rowData.seen_by[0] || !rowData.seen_by.some(seen => seen.id.toString() === Cookies.get('userId')) ? (
          <Button icon="pi pi-circle-fill" className="p-button-sm p-button-info p-mr-2"
                  tooltip="Olvasottra jelöl"
                  tooltipOptions={{position: 'right'}}
                  onClick={() => {
                    axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "notification/" + rowData.id + "/read",
                      {},
                      {
                        params: {},
                        headers: {
                          'Authorization': 'Bearer ' + Cookies.get("userToken"),
                          "Sys-name": Cookies.get("instanceId"),
                          "Preferred-locale": Cookies.get("language")
                        }
                      })
                      .then(response => {
                        window.App.customToastStickyClear()
                        window.App.setState({rerenderNotificationsList: Math.random()})
                      })
                      .catch(error => {
                        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                      })
                  }}/>
        ) : (
          <Button icon="pi pi-circle" className="p-button-sm p-button-info p-mr-2"
                  tooltip="Olvasatlanra jelöl"
                  tooltipOptions={{position: 'right'}}
                  onClick={() => {
                    axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "notification/" + rowData.id + "/unread",
                      {},
                      {
                        params: {},
                        headers: {
                          'Authorization': 'Bearer ' + Cookies.get("userToken"),
                          "Sys-name": Cookies.get("instanceId"),
                          "Preferred-locale": Cookies.get("language")
                        }
                      })
                      .then(response => {
                        window.App.customToastStickyClear()
                        window.App.setState({rerenderNotificationsList: Math.random()})
                      })
                      .catch(error => {
                        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                      })
                  }}/>
        )}
      </React.Fragment>
    );
  }

  useEffect(() => {
    document.title = t('notifications') + ' - ' + process.env.REACT_APP_TITLE;
    window.App.help('/notifications')
    loadLazyData()
  }, [lazyParams, window.App.state.rerenderNotificationsList]);

  return (
    <div className="NotificationsPage p-component p-m-lg-4">
      <HelpComponent type={"site"} position={"TOP_OF_THE_PAGE"} url={"/notifications"}/>
      <Panel>
        <div className={"p-grid"}>
          <div className={"p-col-12 p-lg-4"}>
            <h2 className={"p-m-0"}>{t('notifications_list')}</h2>
          </div>
          <div className={"p-col p-text-right p-col-align-center"}>

          </div>
        </div>
        <DataTable
          ref={dt}
          size={"small"}
          emptyMessage={t('empty_message')}
          value={notifications} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
          onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
          onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
          paginatorTemplate={pager} rows={rows}
          autoLayout={true}
          filterDisplay="menu"
          responsiveLayout={window.App.state.responsiveLayout}
          breakpoint="1365px"
          stripedRows
          dataKey="id"
          onRowClick={(rowData, index, e) => {
            {!rowData.data.seen_by[0] || !rowData.data.seen_by.some(seen => seen.id.toString() === Cookies.get('userId')) ? (
                axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "notification/" + rowData.data.id + "/read",
                  {},
                  {
                    params: {},
                    headers: {
                      'Authorization': 'Bearer ' + Cookies.get("userToken"),
                      "Sys-name": Cookies.get("instanceId"),
                      "Preferred-locale": Cookies.get("language")
                    }
                  })
                  .then(response => {
                    window.App.customToastStickyClear()
                    window.App.setState({rerenderNotificationsList: Math.random()})
                  })
                  .catch(error => {
                    window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                  })
              ) : (
                axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "notification/" + rowData.data.id + "/unread",
                  {},
                  {
                    params: {},
                    headers: {
                      'Authorization': 'Bearer ' + Cookies.get("userToken"),
                      "Sys-name": Cookies.get("instanceId"),
                      "Preferred-locale": Cookies.get("language")
                    }
                  })
                  .then(response => {
                    window.App.customToastStickyClear()
                    window.App.setState({rerenderNotificationsList: Math.random()})
                  })
                  .catch(error => {
                    window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                  })
              )
            }
          }}
        >
          <Column body={actionBodyTemplate} className={"p-py-0 p-text-nowrap p-text-left"}></Column>
          <Column className={"p-d-relative"} style={{position: 'relative', width: '1px', maxWidth: '1px'}}
                  body={(rowData) => {
                    if (rowData.urgent) {
                      return (
                        <>
                          <span className={"urgent-notification"} style={{
                            position: 'absolute',
                            left: 'right',
                            top: '0',
                            height: '100%',
                          }}></span>
                        </>
                      )
                    }
                  }}/>
          <Column field="created_at_snapshot" sortable header={t('created_at')}
                  sortField={"created_at"}
                  filterField={"created_at"}
                  body={(rowData) => {
                    if (rowData.created_at_snapshot !== null) {
                      return (
                        <span>{rowData.created_at_snapshot}</span>
                      )
                    }
                  }}></Column>
          <Column field="title" sortable header={t('title')}></Column>
          <Column field="message" sortable header={t('message')}></Column>
          <Column className={"link p-text-right"} body={(rowData) => {
            if (rowData.link) {
              return (
                <Button className="p-button-sm p-button-info"
                        label={rowData.link.includes('https://') ? t('open_link') : t('more_info')}
                        onClick={() => {
                          if (rowData.link.includes('https://')) {
                            window.open(rowData.link, '_blank', 'noopener,noreferrer');
                          } else {
                            navigate(rowData.link);
                          }
                        }}></Button>
              )
            }
          }}></Column>
        </DataTable>
      </Panel>
    </div>
  )
}
export default withTranslation('common')(_FM_NotificationsPage);
